export default {
  isStartingCalc: false,
  isFetching: false,
  batchProvisionsWithStatus: {},
  processedSuccessfullyFilter: '',
  trialBalancesNotReceivedFilter: '',
  trialBalancesWithErrorsFilter: '',
  calculationErrorsFilter: '',
  otherErrorsFilter: '',
  journalsFilter: '',
  localJournalsFilter: '',
  connections: [],
  connection: null,
  isLoadingCompanyCodesForConnection: false,
  companyCodesForConnection: [],
};
